import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";

const GET_PROVIDER_WITH_FACILITIES = gql(`
    query ProviderWithFacilitiesHook {
        provider {
            providerId
            facilities {
                providerFacilityId
            }
        }
    }
`);

export function useProviderHasFacilities() {
  const [hasFacilities, setHasFacilities] = useState(true);
  const {
    loading: providerFacilitiesQueryLoading,
    data: providerFacilitiesData,
  } = useQuery(GET_PROVIDER_WITH_FACILITIES, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (!providerFacilitiesQueryLoading && providerFacilitiesData?.provider) {
      setHasFacilities(providerFacilitiesData.provider.facilities.length > 0);
    }
  }, [providerFacilitiesQueryLoading, providerFacilitiesData]);

  return hasFacilities;
}
